/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Toast from './sub_components/toast';
import Header from './sub_components/main/header'
import Footer from './sub_components/main/footer'
import * as bannerService from '../services/bannerService'
import "react-datetime/css/react-datetime.css";
import * as _ from 'lodash';
import { showAdminBannerMax } from '../configs/casinoShowList';

class Banner extends Component {
   constructor(props) {
      super(props);
      this.state = {
         message: "",
         banners: [],
         desktop_banners: {},
         mobile_banners: {},
         desktop_upload_type: {},
         mobile_upload_type: {},
         desktop_upload: {},
         mobile_upload: {},
         banner_rows: [],
      };
   }

   async componentDidMount() {

      this.onLoadBanner()
   }

   async onLoadBanner() {
      let banners = await bannerService.getBanner();

      if (banners.items.length > 0) {
         let desktop_banners_arr = banners.items.filter((banner) => { return banner.includes("desktop_banner") })
         let mobile_banners_arr = banners.items.filter((banner) => { return banner.includes("mobile_banner") })

         let desktop_banners = {}
         for (var banner of desktop_banners_arr) {
            desktop_banners[banner.split("_")[2].split(".")[0]] = banner
         }

         let mobile_banners = {}
         for (var banner1 of mobile_banners_arr) {
            mobile_banners[banner1.split("_")[2].split(".")[0]] = banner1
         }
         let banner_rows = []
         for (let index = 0; index < showAdminBannerMax; index++) {
            banner_rows.push(
               <tr>
                  <td>{index + 1}</td>
                  <td>
                     <div className="form-group d-inline-block">
                        <input type="file" className="form-control-file" name={"desktop_banner_" + index} id={"desktop_banner_" + index} onChange={(e) => { this.onImageChoose(e, "desktop", index) }} accept="image/*" />
                     </div>
                     <button className="btn btn-success mp-0 mr-1" title="Upload" onClick={(e) => { this.onImageUpload(e, "desktop", index) }}><i className="fa fa-upload text-white" aria-hidden="true"></i></button>
                  </td>
                  <td>
                     <div className="imgpreview">
                        {!!desktop_banners[index] ?
                           <img src={desktop_banners[index]} alt="" />
                           : <img alt="" />
                        }
                     </div>
                  </td>
                  <td>
                     <div className="form-group d-inline-block">
                        <input type="file" className="form-control-file" name={"mobile_banner_" + index} id={"mobile_banner_" + index} onChange={(e) => { this.onImageChoose(e, "mobile", index) }} accept="image/*" />
                     </div>
                     <button className="btn btn-success mp-0 mr-1" title="Upload" onClick={(e) => { this.onImageUpload(e, "mobile", index) }}><i className="fa fa-upload text-white" aria-hidden="true"></i></button>
                  </td>
                  <td>
                     <div className="imgpreview">
                        {!!mobile_banners[index] ?
                           <img src={mobile_banners[index]} alt="" />
                           : <img alt="" />
                        }
                     </div>
                  </td>
                  <td>
                     {(!!desktop_banners[index] || !!mobile_banners[index]) && <button className="btn btn-danger mp-0 mr-1" title="Delete" onClick={(e) => { this.onImageRemove(e, !!desktop_banners[index] ? desktop_banners[index] : "", !!mobile_banners[index] ? mobile_banners[index] : "", index) }}><i className="fa fa-trash text-white" aria-hidden="true"></i></button>}
                  </td>
               </tr>
            )

         }

         this.setState({ banners: banners.items, desktop_banners: desktop_banners, mobile_banners: mobile_banners, banner_rows: banner_rows })
      } else {
         let desktop_banners = {}
         let mobile_banners = {}
         let banner_rows = []
         for (let index = 0; index < showAdminBannerMax; index++) {
            banner_rows.push(
               <tr>
                  <td>{index + 1}</td>
                  <td>
                     <div className="form-group d-inline-block">
                        <input type="file" className="form-control-file" name={"desktop_banner_" + index} id={"desktop_banner_" + index} onChange={(e) => { this.onImageChoose(e, "desktop", index) }} accept="image/*" />
                     </div>
                     <button className="btn btn-success mp-0 mr-1" title="Upload" onClick={(e) => { this.onImageUpload(e, "desktop", index) }}><i className="fa fa-upload text-white" aria-hidden="true"></i></button>
                  </td>
                  <td>
                     <div className="imgpreview">
                        {!!desktop_banners[index] ?
                           <img src={desktop_banners[index]} alt="" />
                           : <img alt="" />
                        }
                     </div>
                  </td>
                  <td>
                     <div className="form-group d-inline-block">
                        <input type="file" className="form-control-file" name={"mobile_banner_" + index} id={"mobile_banner_" + index} onChange={(e) => { this.onImageChoose(e, "mobile", index) }} accept="image/*" />
                     </div>
                     <button className="btn btn-success mp-0 mr-1" title="Upload" onClick={(e) => { this.onImageUpload(e, "mobile", index) }}><i className="fa fa-upload text-white" aria-hidden="true"></i></button>
                  </td>
                  <td>
                     <div className="imgpreview">
                        {!!mobile_banners[index] ?
                           <img src={mobile_banners[index]} alt="" />
                           : <img alt="" />
                        }
                     </div>
                  </td>
                  <td>
                     {(!!desktop_banners[index] || !!mobile_banners[index]) && <button className="btn btn-danger mp-0 mr-1" title="Delete" onClick={(e) => { this.onImageRemove(e, !!desktop_banners[index] ? desktop_banners[index] : "", !!mobile_banners[index] ? mobile_banners[index] : "", index) }}><i className="fa fa-trash text-white" aria-hidden="true"></i></button>}
                  </td>
               </tr>
            )

         }
         this.setState({ banner_rows: banner_rows })
      }
   }

   async onImageChoose(e, deviceType, index) {
      const self = this
      if (deviceType === "desktop") {
         if (e.target.files[0].size < 184320) { //153600) {
            let file = e.target.files[0];
            let value = e.target.value;
            let reader = new FileReader();
            const image = new Image();
            reader.onloadend = () => {
               // debugger
               if (reader !== null && typeof reader.result == "string") {
                  image.src = reader.result;
               }
               // let desktop_upload = this.state.desktop_upload
               // let desktop_upload_type = this.state.desktop_upload_type
               // desktop_upload_type[index] = value.split(".")[value.split(".").length - 1]
               // desktop_upload[index] = reader.result
               // this.setState({ desktop_upload: desktop_upload, desktop_upload_type: desktop_upload_type })
            }
            reader.readAsDataURL(file);
            image.onload = async function() {
               // debugger
               if(image.width === 1920 && image.height === 300){
                  let desktop_upload = self.state.desktop_upload
                  let desktop_upload_type = self.state.desktop_upload_type
                  desktop_upload_type[index] = value.split(".")[value.split(".").length - 1]
                  desktop_upload[index] = reader.result
                  self.setState({ desktop_upload: desktop_upload, desktop_upload_type: desktop_upload_type })
               } else {
                  self.props.notify("Desktop banner dimensions should be width- 1920px height- 300px and file size- max 180KB", "error")
               }
              };

         } else {
            self.props.notify("Desktop Banner Size must be < 180 KB !", "error")
            document.getElementById("desktop_banner_" + index).value = ""
         }
      }
      else {
         if (e.target.files[0].size < 133120){ //< 102400) {
            let file = e.target.files[0];
            let value = e.target.value;
            let reader = new FileReader();
            const image = new Image();

            reader.onloadend = () => {
               // debugger
               if (reader !== null && typeof reader.result == "string") {
                  image.src = reader.result;
               }
               // let mobile_upload = this.state.mobile_upload
               // let mobile_upload_type = this.state.mobile_upload_type
               // mobile_upload_type[index] = value.split(".")[value.split(".").length - 1]
               // mobile_upload[index] = reader.result
               // this.setState({ mobile_upload: mobile_upload, mobile_upload_type: mobile_upload_type })
            }
            reader.readAsDataURL(file);
            image.onload = async function() {
               // debugger
               if(image.width === 768 && image.height === 300){
                  let mobile_upload = self.state.mobile_upload
                  let mobile_upload_type = self.state.mobile_upload_type
                  mobile_upload_type[index] = value.split(".")[value.split(".").length - 1]
                  mobile_upload[index] = reader.result
                  self.setState({ desktop_upload: mobile_upload, desktop_upload_type: mobile_upload_type })
               } else {
                  self.props.notify("Mobile banner dimensions should be width- 768px height- 300px and file sie- max 130KB", "error")
               }
            };
         } else {
            self.props.notify("Mobile Banner Size must be < 130 KB !", "error")
            document.getElementById("mobile_banner_" + index).value = ""
         }
      }
   }

   onImageUpload(e, deviceType, index) {
      if (deviceType === "desktop") {

         let desktop_upload = this.state.desktop_upload
         let desktop_upload_type = this.state.desktop_upload_type
         if (!!desktop_upload[index]) {

            let data = {
               "file": desktop_upload[index],
               "deviceType": deviceType,
               "position": index,
               "filetype": desktop_upload_type[index]
            }

            bannerService.uploadBanner(data).then((response) => {
               if (response.isSuccess) {
                  this.showToast("Desktop Banner No. " + (index + 1).toString() + " is Successfully Uploaded", "success")
                  delete desktop_upload[index]
                  delete desktop_upload_type[index]
                  document.getElementById("desktop_banner_" + index).value = ""
                  this.setState({ desktop_upload: desktop_upload, desktop_upload_type: desktop_upload_type })
               } else {
                  this.showToast(response.message, "error")
               }
            })
         } else {
            this.showToast("Please Select Image Before Upload !", "error")
         }

      }
      else {

         let mobile_upload = this.state.mobile_upload
         let mobile_upload_type = this.state.mobile_upload_type
         if (!!mobile_upload[index]) {

            let data = {
               "file": mobile_upload[index],
               "deviceType": deviceType,
               "position": index,
               "filetype": mobile_upload_type[index]
            }

            bannerService.uploadBanner(data).then((response) => {
               if (response.isSuccess) {
                  this.showToast("Mobile Banner No. " + (index + 1).toString() + " is Successfully Uploaded", "success")
                  delete mobile_upload[index]
                  delete mobile_upload_type[index]
                  document.getElementById("mobile_banner_" + index).value = ""
                  this.setState({ mobile_upload: mobile_upload, mobile_upload_type: mobile_upload_type })
               } else {
                  this.showToast(response.message, "error")
               }
            })
         } else {
            this.showToast("Please Select Image Before Upload !", "error")
         }
      }
   }

   onImageRemove(e, desktopbanner, mobilebanner, index) {
      let body = {
         "desktopBanner": desktopbanner.split("/")[desktopbanner.split("/").length - 1],
         "mobileBanner": mobilebanner.split("/")[mobilebanner.split("/").length - 1],
      }

      bannerService.removeBanner(body).then((response) => {
         this.onLoadBanner()
         this.showToast("Banner No. " + (index + 1).toString() + " is Successfully Removed", "success")
      });
   }

   showToast(msg, type) {
      let self = this
      this.setState({ toastMsg: msg, toastType: type, showToast: true }, () => {
         setTimeout(() => {
            self.setState({ toastMsg: "", toastType: "", showToast: false })
         }, 3000);
      })
   }

   handleKey(e) {
      if (e.keyCode === 13) {
         this.setState({})
      }
   }

   onChange(e) {
      const name = e.target.name;
      const value = e.target.value;
      this.setState({ [name]: value })
   }

   render() {
      return (
         <div className="bethubs">
            <Header history={this.props.history} />
            <div className="wrapper">
               <div className="container-fluid container-padding-0">
                  <div className="row">
                     <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                        <div className="main-box">
                           <h5 className="text-blue">Banner</h5>
                           <div className="row mt-2">
                              <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                 <div className="table-responsive">
                                    <table id="example" className="table font-12 table-bordered table-sm addpadding mt-2  ">
                                       <thead className="table-dark">
                                          <tr>
                                             <td>Position</td>
                                             <td>Desktop Banner</td>
                                             <td>Desktop Banner Preview</td>
                                             <td>Mobile Banner</td>
                                             <td>Mobile Banner Preview</td>
                                             <td>Action</td>
                                          </tr>
                                       </thead>
                                       <tbody>
                                          {this.state.banner_rows}
                                       </tbody>
                                    </table>
                                 </div>
                              </div>
                              <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                              <small className='text-danger'>
                                 <ol className='pl-3'>
                                    <li>Desktop banner dimensions: width- 1920px height- 300px and file size- max 150KB</li>
                                    <li>Mobile banner dimensions: width- 768px height- 300px and file size- max 100KB</li>
                                 </ol>
                              </small>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
            {!!this.state.showToast && <Toast notification={this.state.toastMsg} type={this.state.toastType} />}
            <Footer />
         </div>
      )
   }
}
function mapStateToProps(state) {
   return {
   };
}
function mapDispatchToProps(dispatch) {
   return {
   };
}
export default connect(mapStateToProps, mapDispatchToProps)(Banner);